import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IWizardForm } from '../../wizard/wizard-form.component';
import {
  append,
  remove,
  merge,
  pick,
  isEmpty,
  has,
  contains,
  omit,
  update,
  nth,
  pipe,
  insert
} from 'ramda/es';
import { DragulaService } from 'ng2-dragula';

export interface IField {
  name: string;
  type: string;
  required: boolean;
  readonly: boolean;
  values?: string[];
}

@Component({
  selector: 'registration-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class RegistrationFormComponent implements OnInit {
  @Input() fields: IField[] = [];
  @Input() showEditButton = true;
  @Output() onUpdate = new EventEmitter<IField[]>();
  @Output() onEdit = new EventEmitter<IField[]>();

  public inputTypes = [
    { id: 'text', name: 'sessions.create.wizard.step1_2_registration.inputs.text' },
    { id: 'email', name: 'sessions.create.wizard.step1_2_registration.inputs.email' },
    { id: 'radio', name: 'sessions.create.wizard.step1_2_registration.inputs.radio' },
    { id: 'multiple', name: 'sessions.create.wizard.step1_2_registration.inputs.checkbox' },
    { id: 'label', name: 'sessions.create.wizard.step1_2_registration.inputs.label' },
    { id: 'textarea', name: 'sessions.create.wizard.step1_2_registration.inputs.textarea' }
  ];

  public dragulaOptions = {
    invalid: this.isInvalidTarget.bind(this),
    moves: this.canMove.bind(this)
  };

  constructor(private translateService: TranslateService, private dragulaService: DragulaService) {}

  ngOnInit() {
    this.dragulaService.drop.subscribe(() => this.ensureEmailFirst());
  }

  edit() {
    this.onEdit.emit(this.fields);
  }

  update() {
    this.onUpdate.emit(this.fields);
  }

  onChange(field: IField, index: number) {
    const isMultiple = contains(field.type, ['radio', 'multiple']);
    // If we change the type of the field, we need to handle the
    // creation of the array of values for multiples fields, otherwise user can't fill the first value
    // And if the users change the field from multiple to simple, we need to remove the 'values' key
    this.fields = update(
      index,
      isMultiple
        ? !has(['values'], field)
          ? Object.assign(field, { values: [''] })
          : field
        : omit(['values'], field),
      this.fields
    );
  }

  removeField(id: number) {
    this.fields = remove(id, 1, this.fields);
  }

  addField() {
    this.fields = append({ type: 'none', readonly: false }, this.fields);
    this.update();
  }

  isValid() {
    return this.fields.filter(field => field.type === 'none' || field.name === '').length === 0;
  }

  addValue(event: any, field: any) {
    event.preventDefault();
    field.values.push('');
  }

  removeValue(field: IField, index: number) {
    field.values = remove(index, 1, field.values);
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  private ensureEmailFirst() {
    const index = this.fields.findIndex(field => field.name === 'Email');
    if (index > 0) {
      const field = nth(index, this.fields);
      setTimeout(() => {
        this.fields = pipe(remove(index, 1), insert(0, field))(this.fields);
      }, 0);
    }
  }

  private isInvalidTarget(el, source, handle, sibling) {
    return this.hasClass(el, 'notdraggable');
  }

  private canMove(el, source, handle, sibling) {
    return this.hasClass(handle, 'position') || this.hasClass(handle.parentElement, 'position');
  }

  private hasClass(el: any, name: string) {
    return new RegExp('(?:^|\\s+)' + name + '(?:\\s+|$)').test(el.className);
  }

  private addClass(el: any, name: string) {
    if (!this.hasClass(el, name)) {
      el.className = el.className ? [el.className, name].join(' ') : name;
    }
  }
  private removeClass(el: any, name: string) {
    if (this.hasClass(el, name)) {
      el.className = el.className.replace(new RegExp('(?:^|\\s+)' + name + '(?:\\s+|$)', 'g'), '');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/registration/form/form.component.ts